// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function ($) {

  var headerHeight = $('header').innerHeight();

  // ① クリック時
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);

    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });

  // ② ページ遷移後
  if (location.hash) {
    var target = $(location.hash);

    if (target.length > 0) {
      // 一瞬ジャンプするのを防ぐ
      $('html, body').scrollTop(0);

      setTimeout(function () {
        var position = target.offset().top - headerHeight - 100;
        $("html, body").animate({ scrollTop: position }, 0);
      }, 100);
    }
  }

});
